import { render, staticRenderFns } from "./upload-medical-records-form.html?vue&type=template&id=260dbaab&scoped=true&external"
import script from "./upload-medical-records-form.js?vue&type=script&lang=js&external"
export * from "./upload-medical-records-form.js?vue&type=script&lang=js&external"
import style0 from "./upload-medical-records-form.scss?vue&type=style&index=0&id=260dbaab&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260dbaab",
  null
  
)

export default component.exports